import React, { useState } from "react";
import { Button, Input } from "../../../BP2Components";
import { useDispatch } from "react-redux";
import IntlMessages from "@util/IntlMessages";
import { useIntl } from "react-intl";

import "./settings.less";
import { setWidgetInSheetParams } from "../../../../appRedux/actions/Boards";

const FormV3Settings = ({ value, onPreview }) => {
   const dispatch = useDispatch();
   const intl = useIntl();

   const [settings, setSettings] = useState({
      ...value,
   });
   const handleSubmit = (e) => {
      e.preventDefault();
      dispatch(setWidgetInSheetParams(settings));
      onPreview?.();
   };
   const handleChangeInput = (name, e) => {
      setSettings({ ...settings, [name]: e.target.value });
   };

   return (
      <div className="formV3-settings-container">
         <div className="formv3-option-container">
            <span style={{ width: "100px" }}>
               <IntlMessages id="settings.formId" />
            </span>
            <Input
               type="text"
               name="formId"
               defaultValue={value.formId}
               onChange={(e) => handleChangeInput("formId", e)}
               style={{ width: "200px" }}
            />
         </div>
         <div className="formv3-option-container">
            <span style={{ width: "100px" }}>
               <IntlMessages id="settings.dataId" />
            </span>
            <Input
               type="text"
               name="dataId"
               defaultValue={value.dataId}
               onChange={(e) => handleChangeInput("dataId", e)}
               style={{ width: "200px" }}
            />
         </div>

         <Button
            key="formv3-settings-save-btn"
            buttonType="primary"
            onClick={handleSubmit}
            style={{ float: "right" }}
         >
            <IntlMessages id="global.preview" />
         </Button>
      </div>
   );
};

export default FormV3Settings;
